// Hidden from cards and columns only; totals still include these groups.
export const PAY_PER_USE_HIDDEN_OPERATION_GROUPS: readonly string[] = [
  'page.payPerUseMetrics.operation.vehicleDataScan',
];
